import "core-js/modules/es6.function.name";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var GenericElementMapper =
/*#__PURE__*/
function () {
  function GenericElementMapper() {
    _classCallCheck(this, GenericElementMapper);
  }

  _createClass(GenericElementMapper, [{
    key: "mapElement",
    value: function mapElement(response) {
      if (!response) {
        throw Error("Invalid response for mapping element");
      }

      var element = response.element;
      return {
        codename: element.codename,
        name: element.name,
        type: element.type,
        options: element.options ? element.options : [],
        taxonomyGroup: element.taxonomy_group
      };
    }
  }]);

  return GenericElementMapper;
}();